
import { Component, Prop, Vue } from "vue-property-decorator";
import { Answer } from "@/lib/model/exam/result";
import DescribeData from "@/views/paper/paper-result-report/component/describe.vue";
import dimendionDesc from "@/lib/dimension/high-low-desc";
import DialogOCEAN from "./dialog-OCEAN.vue";
import BtnBase from "./btn-base.vue";

@Component({ components: { DescribeData, DialogOCEAN, BtnBase } })
export default class Psychological extends Vue {
  @Prop() index!: number;
  @Prop({ type: Answer, default: () => new Answer() }) mindData!: Answer;
  @Prop({ default: false }) pdfIng!: boolean;

  visible = false; // 弹窗
  // 纬度(高/低)描述
  dimendionDesc(dimensionName: string) {
    if (!dimendionDesc[dimensionName]) return {};
    return dimendionDesc[dimensionName];
  }
}
